import React, { useContext } from "react";
import {
  Table,
} from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import EmployeeFttbHourStore from "../../../app/stores/employeefttbhourStore";

const EmployeeFttbHourList: React.FC = () => {
  const employeefttbhourStore = useContext(EmployeeFttbHourStore);
  const { employeefttbhournamesByDate, submitting } = employeefttbhourStore;
  return (
    <Table compact size="small" unstackable>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Financial Year</Table.HeaderCell>
          <Table.HeaderCell>Pay Run</Table.HeaderCell>
          <Table.HeaderCell>Date</Table.HeaderCell>
          <Table.HeaderCell>Order No.</Table.HeaderCell>
          <Table.HeaderCell>Hours</Table.HeaderCell>
          <Table.HeaderCell>Code</Table.HeaderCell>
          <Table.HeaderCell>Note</Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {employeefttbhournamesByDate.map((fttbhour) => (
          <Table.Row key={fttbhour.id}>
            <Table.Cell>{fttbhour.financialYear}</Table.Cell>
            <Table.Cell>{fttbhour.payRun}</Table.Cell>
            <Table.Cell>
              {fttbhour.date.substr(8, 2) +
                "/" +
                fttbhour.date.substr(5, 2) +
                "/" +
                fttbhour.date.substr(0, 4)}
            </Table.Cell>
            <Table.Cell>{fttbhour.orderNumber}</Table.Cell>
            <Table.Cell>{fttbhour.hours}</Table.Cell>
            <Table.Cell>{fttbhour.code}</Table.Cell>
            <Table.Cell>{fttbhour.note}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

export default observer(EmployeeFttbHourList);
